import { Box as BoxScheme } from '@data/buildingProjects/DesignSchemes/SingleBuilding/Box';
import { ConvexHull } from '@data/buildingProjects/DesignSchemes/SingleBuilding/ConvexHull';
import { OrientedVolume } from '@data/buildingProjects/DesignSchemes/SingleBuilding/OrientedVolume';
import { FloorBased } from '@data/buildingProjects/DesignSchemes/FloorBased/FloorBased';

import { BoxView } from './SingleVolume/BoxView';
import { ConvexHullView } from './SingleVolume/ConvexHullView';
import { OrientedVolumeView } from './SingleVolume/OrientedVolumeView';
import { FloorBasedView } from './FloorBased/FloorBasedView';

import { DesignScheme } from '@data/buildingProjects/DesignSchemes/designScheme';

// Maps constructor name to UI component, completely decoupling data from UI:
export const designSchemeUIRegistry = new Map<new (...args: any[]) => DesignScheme, React.ComponentType<any>>([
    [FloorBased, FloorBasedView],
    [BoxScheme, BoxView],
    [ConvexHull, ConvexHullView],
    [OrientedVolume, OrientedVolumeView],
]);
